<script>

export default {
  name: 'GoogleMapMarkers',
  props: {
    markers: Array,
    userLocation: Object,
    refObject: Object,
    pinColor: { default: '#016fb9' }
  },
  computed: {
    map () {
      return this.$parent.map
    },
    google () {
      return this.$parent.google
    }
  },
  methods: {
    panToPosition (lat, lng) {
      if (typeof lat === 'string') {
        lat = Number(lat.replace(',', '.'))
      }

      if (typeof lng === 'string') {
        lng = Number(lng.replace(',', '.'))
      }

      const { LatLng } = this.google.maps

      this.map.panTo(new LatLng(lat, lng))
      this.map.setZoom(18)
      return true
    },
    markerUserLocation () {
      const { Marker, LatLng } = this.google.maps
      return new Marker({
        position: new LatLng(this.userLocation.lat, this.userLocation.lng),
        icon: require('@/assets/icons/circle.svg'),
        map: this.map,
        clickable: true
      })
    },
    processClick (googleMarker) {
      this.$parent.processMarkerClick(googleMarker)
    }
  },
  data () {
    return { googleMarkers: [] }
  },
  mounted () {
    const svgMarker = {
      path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
      fillColor: this.pinColor,
      fillOpacity: 1,
      strokeWeight: 0,
      rotation: 0,
      scale: 2
    }
    this.markerUserLocation()
    this.markers.forEach(marker => {
      const { Marker, LatLng } = this.google.maps

      const googleMarker = new Marker({
        title: marker.name,
        icon: svgMarker,
        position: new LatLng(marker.lat, marker.long),
        map: this.map,
        refObject: this.refObject
      })

      googleMarker.addListener('click', () => this.processClick(googleMarker))

      this.googleMarkers.push(googleMarker)
    })
  },
  render () {
    return null
  }
}

</script>
